import { Component } from "@angular/core";

/**
 * Presentational fragment for the static SchedMed logo header row that appears
 * identically at the top of every patient-notification email card.
 *
 * Uses an attribute selector on a <tr> so the host element IS the table row the
 * original markup used (no extra DOM node is introduced and the rendered output
 * stays visually identical). The content is fully static.
 */
@Component({
  selector: "tr[appNotificationLogo]",
  templateUrl: "./notification-logo.component.html",
})
export class NotificationLogoComponent {}
